








































import { Component, Prop } from 'nuxt-property-decorator'
import {
  computed,
  defineComponent,
  ref,
  useRoute,
  useRouter,
  watch,
} from '@nuxtjs/composition-api'
import InputSelect from '../components/Inputs/InputSelect.vue'
import { SelectOption } from '../contracts/FormInput'
import { sectionCoreProps } from '@/mixins/sectionCore'
import Tabs from '@/components/Tabs'
import BlockListArchiveItems from '@/components/BlockListArchiveItems.vue'
import BlockBreadCrumbs from '@/components/BlockBreadCrumbs.vue'
import SectionBasic from '@/components/SectionBasic.vue'

@Component
class SectionDocumentsList {
  @Prop() readonly list: ReadonlyArray<any> = []
}

export default defineComponent({
  name: 'SectionDocumentsList',
  components: {
    InputSelect,
    Tabs,
    BlockListArchiveItems,
    BlockBreadCrumbs,
    SectionBasic,
  },
  mixins: [sectionCoreProps],
  props: SectionDocumentsList.options.props,
  setup(props) {
    const route = useRoute()
    const router = useRouter()
    const hasFilter = ref<boolean>(false)

    /**
     * TODO: Это скорее всего лучше вынести в отдельную секцию,
     * Обсуждалось в Чубаровым, пока оставляем так, но нужно будет сделать отдельную
     * секцию, которая будет наследоваться от этой секции и вынести в неё всю логику с
     * фильтрами.
     */
    if (
      route.value.path ===
      '/about/dokumenty/pravila-strakhovaniya-i-strakhovye-tarify'
    ) {
      hasFilter.value = true
    }

    const documentNumber = ref<SelectOption>(null)

    const selectOptions = ref<SelectOption[]>([])
    const docCode = computed(() => route.value.query?.doccode)

    const clear = () => {
      documentNumber.value = null
    }

    if (hasFilter.value) {
      props.list?.forEach((list) => {
        return list?.list?.forEach((doc) => {
          if (doc.title) {
            selectOptions.value.push({
              name: doc.title,
              value: doc.title,
            })
          }
        })
      })

      selectOptions.value = [
        ...new Map(
          selectOptions.value.map((item) => [item.name, item])
        ).values(),
      ]

      selectOptions.value = selectOptions.value.sort((a, b) => {
        return +a.value - +b.value
      })

      if (docCode.value && hasFilter.value) {
        documentNumber.value =
          selectOptions.value.find((i) =>
            i.value.includes(docCode.value.toString())
          ) || null
      }
    }

    const filterDocuments = computed(() => {
      if (!documentNumber.value) return props.list
      return (JSON.parse(JSON.stringify(props.list)) as [])?.map((docTab) => {
        docTab.list = docTab.list
          ?.filter((docItem) => !docItem.masterId)
          .filter((docItem) =>
            docCode.value
              ? docItem.title.includes(docCode.value)
              : docItem.title === documentNumber.value.value
          )
        return docTab
      })
    })


    const modifiedString = ref('Дата редактирования')

    watch(documentNumber, () => {
      const query = { ...route.value.query }
      delete query.doccode
      router.replace({ query })
    })
    return {
      hasFilter,
      modifiedString,
      documentNumber,
      selectOptions,
      filterDocuments,
      clear,
    }
  },
})
